module.exports = __webpack_public_path__ + "static/media/54_tn.a1efc181.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/54_tn.jpg
// module id = 362
// module chunks = 0